import constant from "../../../../../constants/constant";
import { findConstantLabel, getDropdownValue } from "../../../../../constants/utils";
import { AddInvoiceData, ProductData } from "../interface";
import { EditInvoiceDetail } from "./interface"

interface HandleEditDataProps{
    response: EditInvoiceDetail;
    setInvoiceData:(value:AddInvoiceData)=>void;
    setProductData:(value:ProductData[])=>void;
}

export const useEditData = () => {

    const handleEditData = ({
        response,
        setProductData,
        setInvoiceData,
      }: HandleEditDataProps) => {
        const customProduct: ProductData[] = response.product_details.map((item, index) => {
          const initialCost = item?.cost_amount / (1 - (item?.discount_percent * 0.01))
          const discountAmount = (item?.discount_percent / 100) * initialCost;
          const subTotalAmount = item?.total_price ;
          const gstAmount =  item?.product_type_gst_percentage*0.01*subTotalAmount;
          return {
          ...item.product,
          sum_qty: item?.quantity,
          sum_total_price: item?.total_price,
          cost_amount: item?.cost_amount,
          qty: item?.quantity,
          total_price: item?.total_price,
          gst_amount: item?.gst_amount,
          srp_amount: item?.product?.product_srp,
          custom_index: index,
          additional_keys: {
            cost_amount: initialCost,
            discount_amount: discountAmount,
            discount_percentage: item?.discount_percent,
            qty: item?.quantity,
            subtotal_amount: subTotalAmount,
            gst_amount: gstAmount,
            grand_total_amount: item?.total_price + gstAmount,
            total_product_with_case: item?.product?.product_with_case ? item?.quantity : 0,
          },
        }}
      );
      
        const tempInvoiceData: AddInvoiceData = {
          invoice_id: response?.invoice_id_display,
          supplier_invoice_number: response?.supplier_invoice_number,
          local_supplier_name:response?.local_supplier_name || '',
          supplier_invoice_date: response?.supplier_invoice_date,
          category: getDropdownValue(constant.INVOICE_CATEGORY, response.category),
          actual_invoice: String(response?.actual_invoice),
          remark: response?.remark,
          attachments: response?.attachments ?? [],
          gst_invoice: response?.gst_invoice ? constant.GST_Invoice[0] : constant.GST_Invoice[1],
          invoice_file:[]
        };
        setProductData(customProduct);
        setInvoiceData(tempInvoiceData);
      };
      

    return {
        handleEditData
    }
}